// Full app shell: persistent Drawer (Sidenav) + Header + main content (<Outlet/>).
// Also keeps the document title in sync via useRouteTitle, mounts the IdleWatcher,
// and shows the SplashScreen while Auth0 is still resolving.
import { useState } from 'react';
import { Box, Drawer, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Header } from './Header';
import { Sidenav } from './Sidenav';
import { IdleWatcher } from './IdleWatcher';
import { SplashScreen } from './SplashScreen';
import { useRouteTitle } from '@/hooks/useRouteTitle';
import { useDialog } from './dialogs/useDialog';
import { ProfileModal } from './dialogs/ProfileModal';

const DRAWER_WIDTH = 260;

export function AppLayout() {
  const [open, setOpen] = useState(true);
  const { isLoading, isAuthenticated } = useAuth0();
  const { open: openDialog } = useDialog();
  useRouteTitle();

  if (isLoading) {
    return <SplashScreen />;
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {isAuthenticated && (
        <Drawer
          variant="persistent"
          open={open}
          sx={{
            width: open ? DRAWER_WIDTH : 0,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              boxSizing: 'border-box',
            },
          }}
        >
          <Sidenav />
        </Drawer>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {isAuthenticated && (
          <Header
            onToggleSidebar={() => setOpen((o) => !o)}
            onOpenProfile={() => {
              void openDialog((close) => <ProfileModal onClose={close} />);
            }}
          />
        )}
        <Toolbar sx={{ display: { xs: 'none' } }} />
        <Box component="main" sx={{ flex: 1, p: 3, overflow: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
      <IdleWatcher />
    </Box>
  );
}
